import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl,apiHost } from '../stores/APIEndpoints';



import { getCategoriesQuery } from './Queries';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Products. The Service is unavailable. Please try after sometime." };

export default class ProductListStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    products = [];
    rowCount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;

        makeObservable(this, {
            state: observable,
            message: observable,
            products: observable,
            rowCount: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchTests: action,
            fetchProfiles: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }




    /**
     * 
     * Obtain the List of Tests from the .Net API endpoint
     * 
     */
    fetchTests = async () => {
        const apiEndpoint = `${erpApiurl}/api/carbon/GetTestList`;
        this.fetchData(apiEndpoint);
    }

    /**
    * 
    * Obtain the List of Profiles from the .Net API endpoint
    * 
    */
    fetchProfiles = async () => {
        const apiEndpoint = `${erpApiurl}/api/carbon/GetProfileList`;
        this.fetchData(apiEndpoint);
    }

    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchData = async (url) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.products = data;
            this.rowCount = data.length;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    approvePostables = () => {
        return {Key:"7f76ba6a-8c81-42c2-826d-f9217a2f1ca3"}
    }

    /**
     * This will update both the tests and the profiles
     */
    approve = async () => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = `${erpApiurl}api/carbon/MassApprovePrice`;

        try {
            await this.apiProxy.asyncPost(apiEndpoint, this.approvePostables());
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }


    fetchCategories = async () => {

        try {
            const response = await this.apiProxy.query(apiHost, getCategoriesQuery, null);
            const result = await response.json();
            console.log(result);
            if(result.data.getPrices === undefined) {
                this.state = ERROR;
                this.message = ERROR_MESSAGE;
                return;
            }
            const rowData = result.data.getCategories;
            console.log(rowData);
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE;
    
        }
    }

}
